import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropdown from '../utility/Dropdown';
import VoteItem from './VoteItem';
import VoteItemPopup from './VoteItemPopup';
import Button from '../utility/Button';
import ErrorDisplay from '../utility/ErrorDisplay';
import PropTypes from 'prop-types';
import LoadingSpinner from '../utility/LoadingSpinner';
import LottieLoader from '../utility/LottieLoader';
import PriceNotes from '../utility/PriceNotes';
import { Helmet } from 'react-helmet';
import i18n from 'i18next';
import Cookies from 'js-cookie';
import { withTranslation } from 'react-i18next';

import { getRandomInt } from '../../js/utility';

import iconBYOC from '../../images/icons/icon_fordvehicle_yellow.png';

import fordLogoWhite from '../../images/fga_logo_white.png';

import {
  fetchTrips,
  fetchAdditionalTrips,
  toggleActiveTripPopUp,
  toggleShowAllTrips,
  setSortFilter
} from '../../actions/trip';

import {
  fetchContestItems,
  setContestMode,
  setSignupFlow,
  toggleActiveContestPopUp,
  setContestStep,
  setActiveContestPopUp,
  toggleActiveAuthPopUp
} from '../../actions/contest';

import { setLightboxVideo, toggleLightbox } from '../../actions/lightbox';

import { clearApiError } from '../../actions/api';

import {
  INITIAL_TRIPS_TO_SHOW as initialTripsToShow,
  sortFilters,
  vehicleFilters,
  SITE_TITLE
} from '../../constants';
import AuthPopup from './AuthPopup';

const maxVideos = parseInt(process.env.COVER_VIDEO_NUM);
let videoArr = [];
for (let i = 1; i < maxVideos + 1; i++) {
  videoArr.push(`/videos/fordVideo${i === 1 ? '' : i}.mp4`);
}

let refetched = false;

const delay = ms => new Promise(res => setTimeout(res, ms));

class Contest extends Component {
  constructor(props) {
    super(props);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
  }

  componentDidMount() {
    const {
      setContestMode,
      toggleActiveTripPopUp,
      fetchContestItems
    } = this.props;

    toggleActiveTripPopUp(false); // Off popup
    fetchContestItems(); //Fetch contest API
    setContestMode(true); // Enable contest mode on for authentication
  }

  componentDidUpdate() {
    const {
      signedIn,
      fetchContestItems,
      signupFlow,
      contestMode,
      setContestStep,
      activeContestId,
      toggleActiveContestPopUp,
      hasVoted
    } = this.props;

    if (signedIn) {
      // If login from selected contest popup but havent voted
      if (activeContestId !== null && !hasVoted) {
        setContestStep('voted');
        toggleActiveContestPopUp(true);
      }
      // If login from selected contest popup but voted
      if (activeContestId !== null && hasVoted) {
        setContestStep('alreadyVoted');
        toggleActiveContestPopUp(true);
      }
    }
  }

  componentWillUnmount() {
    const { setContestMode } = this.props;
    setContestMode(false); // Disable contest mode on for authentication
  }

  handleChangeFilter(val) {
    const sortFilter = sortFilters.find(filter => filter.name === val);
    this.props.setSortFilter(sortFilter);
  }

  handleVideoButtonClick() {
    this.props.setLightboxVideo(
      `/videos/ford_full_${i18n.language || i18n.languages[0]}.mp4`,
      false
    );
    this.props.toggleLightbox(true, true);
  }

  render() {
    const {
      contestLoading,
      error,
      showPopup,
      showAuthPopup,
      contestItems,
      hasVoted,
      toggleActiveTripPopUp,
      popupAuthError,
      signedIn,
      t
    } = this.props;

    if (error && error.response.status !== 401) {
      return (
        <div className='container'>
          <ErrorDisplay error={error} />
        </div>
      );
    }

    if (contestLoading) {
      return <LottieLoader />;
    }

    return (
      <>
        <Helmet>
          <title>{SITE_TITLE}</title>
        </Helmet>

        {showPopup ? <VoteItemPopup /> : null}
        {showAuthPopup ? <AuthPopup /> : null}

        <div className='fe-home-video-container'>
          <div className='container fe-home-video-header'>
            <img src={fordLogoWhite} alt='' />
            <h1 className='fe-home-video-heading'>
              <span>
                {t('home:mainTitleL4')}
                <br />
                {t('home:mainTitleL5')}
                <br />
              </span>
              <p className="mt10">Experience the Ford Ranger Lifecycle</p>
            </h1>
            <h1 className='fe-home-video-heading desktop'>
              <span>
                {t('home:mainTitleL4')}
                <br />
                {t('home:mainTitleL5')}
              </span>
              <br />
              Experience the Ford Ranger Lifestyle
            </h1>
            <div className='fe-home-video-controls contest-video'>
              <Button className="contest-btn" onClick={this.handleVideoButtonClick.bind(this)}>
                Live the Ford Ranger life
              </Button>
            </div>
          </div>
          <video
            autoPlay
            loop
            muted
            playsInline
            className='fe-home-video'
            style={{ backgroundColor: 'black' }}
          >
            <source src={videoArr[getRandomInt(maxVideos)]} type='video/mp4' />
          </video>
        </div>
        <section className='fe-contest-step'>
          <div className='container'>
            <span className='header'>
              Let's Create The Most Adventurous Test Drive
            </span>
            <p className='colored'>
              Stand a chance to win an all expense paid Getaway*
            </p>
            <span className='grayTxt headerTitle'>
              <p className="">We're on a mission to create Ford Ranger Getaways, Malaysia's
                adventure test drive that lets you explore our country, and truly
                live the Ranger lifestyle.</p>

              <span className="headerGap">We have chosen some of Malaysia's most unique destinations for you
              to experience.</span>
            </span>
            <p className='colored'>All You Need To Do Is</p>
            <div className='align-left'>
              <ul>
                <li>
                  Sign up for Ford Ranger Getaways account{' '}
                  {!signedIn && (
                    <span
                      className='link'
                      onClick={() => {
                        this.props.toggleActiveAuthPopUp(true);
                        this.props.setSignupFlow('signup');
                      }}
                    >
                      <span>here</span>
                    </span>
                  )}
                </li>
                <li>Vote for your most preferred destination</li>
                <li>Tell us what does a Ford Ranger life mean to you?</li>
              </ul>
            </div>
            <div className='footer'>
              <p className="grayTxt">*Terms & Condition apply</p>
            </div>
          </div>
        </section>
        <section className='fe-contest-vote-list'>
          <div className='container'>
            <div className='row no-gutters'>
              <div className="alignCenter col-12">
                <h2 className="colored" >Vote For Your Favourite Gateway</h2>
                <br></br>
              </div>
              {Array.isArray(contestItems) &&
                contestItems.map(res => (
                  <div key={res.id} className='col-xl-3 col-sm-6 col-6'>
                    <VoteItem voteItemDetail={res} hasVoted={hasVoted} />
                  </div>
                ))}
            </div>
          </div>
        </section>
      </>
    );
  }
}

Contest.propTypes = {
  contestItems: PropTypes.array,
  error: PropTypes.object,
  showPopup: PropTypes.bool.isRequired,
  toggleActiveTripPopUp: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  contestLoading: PropTypes.bool.isRequired,
  setSignupFlow: PropTypes.func,
  popupAuthError: PropTypes.any
};

const mapStateToProps = ({
  tripState,
  apiState,
  lightboxState,
  authState,
  contestState
}) => ({
  error: apiState.error,
  contestLoading: contestState.loading,
  contestItems: contestState.contestItems,
  showPopup: contestState.showPopup,
  showAuthPopup: contestState.showAuthPopup,
  popupAuthError: authState.popupAuthError,
  signedIn: authState.signedIn,
  signupFlow: contestState.signupFlow,
  contestMode: contestState.contestMode,
  activeContestId: contestState.activeContestId,
  hasVoted: contestState.hasVoted
});

const mapDispatchToProps = {
  fetchTrips,
  fetchAdditionalTrips,
  fetchContestItems,
  toggleActiveTripPopUp,
  clearApiError,
  toggleShowAllTrips,
  setSortFilter,
  setLightboxVideo,
  toggleLightbox,
  setContestMode,
  setSignupFlow,
  toggleActiveContestPopUp,
  setContestStep,
  setActiveContestPopUp,
  toggleActiveAuthPopUp
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Contest)
);
